import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import ReactDOM from "react-dom";
import { twMerge } from "tailwind-merge";

interface LogoutConfirmationModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({ onCancel, onConfirm }) => {
  const theme = useAtomValue(themeAtom);

  return ReactDOM.createPortal(
    <div
      className={twMerge(
        "fixed inset-0 z-50 flex items-center justify-center bg-opacity-40 backdrop-blur-sm",
        theme.home.tailwind.pageBackground,
      )}
      onClick={onCancel}
    >
      <div
        className={twMerge(
          "z-50 flex w-[360px] flex-col rounded-xl border px-5 py-5 shadow-xl",
          theme.uwhcAssistant.border,
          theme.home.tailwind.panelBackground,
          theme.home.tailwind.textDefault,
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={twMerge("mb-2 text-[18px] font-bold", theme.uwhcAssistant.text)}>Confirm logout</div>
        <p className={twMerge("mb-5 text-[14px]", theme.uwhcAssistant.text)}>
          Are you sure you want to log out?
        </p>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className={twMerge(
              "h-9 rounded border px-4 text-[14px] focus:outline-none focus:ring",
              theme.uwhcAssistant.sendBorder,
              theme.uwhcAssistant.chatBg,
              theme.headerComponent.tailwind.buttonText,
              theme.headerComponent.tailwind.buttonFocusRing,
            )}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={twMerge(
              "h-9 rounded border px-4 text-[14px] focus:outline-none focus:ring",
              theme.uwhcAssistant.sendBorder,
              theme.uwhcAssistant.chatBg,
              theme.headerComponent.tailwind.buttonText,
              theme.headerComponent.tailwind.buttonHoverBg,
              theme.headerComponent.tailwind.buttonHoverText,
              theme.headerComponent.tailwind.buttonFocusRing,
            )}
          >
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
